// Store the default background color from html on page load
var defaultColor = window.getComputedStyle(document.documentElement).backgroundColor;

window.addEventListener('scroll', function() {
    var el = document.querySelector('.mount-header');
    var atTop = window.pageYOffset === 0;
    
    if (atTop) {
        el.classList.add('is-top');
    } else {
        el.classList.remove('is-top');
    }
    
    // Check for lossie-farbwechsel sections and apply html background color
    var colorSections = document.querySelectorAll('.lossie-farbwechsel');
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    var colorToApply = defaultColor;
    
    // Find the first section that is above the bottom of the viewport
    colorSections.forEach(function(section) {
        var rect = section.getBoundingClientRect();
        
        // Section's top is above the bottom of viewport (section has entered)
        if (rect.top < viewHeight) {
            var bodyBg = section.dataset.bodyBg;
            if (bodyBg) {
                colorToApply = bodyBg;
            }
        }
    });
    
    // Apply the determined color
    document.documentElement.style.backgroundColor = colorToApply;
});

// Optional: Add transition for smooth color changes
document.documentElement.style.transition = 'background-color 0.3s ease';